import * as React from 'react';
import './company.css';

export default class Company extends React.Component<any> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    render() {
        const content = this.props.content;

        return (
            <div className="banner">
                {content !== undefined &&
                    Object.keys(content).map((key) => {
                        const image = {
                            backgroundImage: `url(${
                                content[key].fields.mynd.fields.file.url
                            })`,
                        };
                        return (
                            <div
                                key={key}
                                className="banner-image"
                                style={image}
                            >
                                <div className="scroll">
                                    Skrunaðu <span className="arrow" />{' '}
                                    <span className="arrow" />{' '}
                                    <span className="arrow" />{' '}
                                </div>
                                <div className="banner-text-container item-container">
                                    <h2>{content[key].fields.textiMeMynd}</h2>

                                    <button>Skoða nánar</button>
                                </div>
                            </div>
                        );
                    })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/company-page/company/company.tsx